import React from "react";

const Contact = () => {
  return (
    <>
      <div className="mainContact">
        <h1>Email Me!</h1>
        <p>delrosario.bea@gmail.com</p>
      </div>
    </>
  );
};

export default Contact;

//probably would add a contact form here